/* eslint-disable react-hooks/exhaustive-deps */
import { FunctionComponent as F, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { useAppDispatch } from "../../core/store/hooks";
import Typography from '@mui/material/Typography';
import DialogContent from '@mui/material/DialogContent';
import ProductsTable from "./ProductsTable";
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import { LISTINGS, PROTOCOL } from "../../core/router/paths";
import { IState } from "../../core/store/store";
import { swapFromSameVendorAsync } from "../../core/store/protocol/protocol.thunks";
import LoadingGifMedium from "../UI/Icons/LoadingGif/LoadingGifMedium";
import { updateProducts } from "../../core/store/products/products.slice";
import { retrieveSimilarProductsAsync } from "../../core/store/products/products.thunks";


interface LocationState
{
  dosingId?: number
}

interface Params
{
  productId?: string,
  protocolId?: string
}

const SimilarProducts: F = () =>
{
  const navigate = useNavigate();
  const location = useLocation();
  const [locationState] = useState<LocationState | undefined>(location.state);
  const params = useParams() as Params;
  const dispatch = useDispatch();
  const appDispatch = useAppDispatch();

  const products = useSelector((state: IState) => state.products.products)
    ?.filter(p => p.deliverableListingsForUser);
  const storedProductId = useSelector((state: IState) => state.listings.productId);

  const [productsRetrieved, setProductsRetrieved] = useState(Boolean(products));
  useEffect(() => setProductsRetrieved(Boolean(products)), [products]);

  const dosings = useSelector((state: IState) => state.protocol.protocols
    .find(p => p.protocolId === Number(params.protocolId))?.dosings);

  const dosingId = locationState?.dosingId;
  const productId = dosings?.find(r => r.dosingId === locationState?.dosingId)?.productId || params.productId;

  useEffect(() =>
  {
    if(!productId)
      return;

    dispatch(updateProducts(undefined));
    appDispatch(retrieveSimilarProductsAsync(Number(productId)));
  }, []);

  if(!dosings)
    return <></>;

  const handleProductClick = async(productId: number) =>
  {
    if(dosingId && await appDispatch(swapFromSameVendorAsync(dosingId, Number(params.protocolId), productId)))
      return navigate(PROTOCOL + "/" + params.protocolId);

    navigate("../" + LISTINGS, {
      relative: 'path',
      state: { retrieveListings: productId !== storedProductId, swapDosingId: dosingId, productId } });
  };

  return (
    <Dialog
      maxWidth='md'
      fullWidth
      PaperProps={{ sx: { p: '15px' }}}
      open={true}
      onClose={() => navigate(PROTOCOL + "/" + params.protocolId)}>
      <DialogContent>

        <Typography style={{ fontSize: 30, fontWeight: 600, marginBottom: 24 }}>
          Similar Products
        </Typography>

        {(productsRetrieved && !products?.length) ?
          <Typography
            variant='body2'
            style = {{ userSelect: 'none' }}
            gutterBottom>
            {"No similar products found."}
          </Typography> :
          <></>}

        {productsRetrieved ?
          <ProductsTable handleProductClick={handleProductClick}/> :
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <LoadingGifMedium/>
          </Box>}

      </DialogContent>
    </Dialog>);
};

export default SimilarProducts;
